import Ajax from '@/lib/ajax'

export default {
  /**
   * 查询自定义分组商品列表
   */
  getList(
    pageSize: number,
    currentPage: number,
    categoryId: string,
    keyWord?: string
  ) {
    let params = {
      KeyWord: keyWord,
      CustomCategoryId: categoryId,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Sorting: 'id desc',
    }
    return Ajax.get(`/api/productManagement/customCategoryProduct`, {
      params: params,
    })
  },
  /**
   * 删除商品
   */
  deleteProduct(ids: any[]) {
    let list = ids || []
    let params = ''
    list.forEach((item, index) => {
      if (index === 0) {
        params = '?'
      }
      params += 'ids=' + item
      if (index < list.length - 1) {
        params += '&'
      }
    })
    return Ajax.delete(`/api/productManagement/customCategoryProduct${params}`)
  },
  /**
   * 添加商品
   */
  addProducts(data: any[]) {
    return Ajax.post(`/api/productManagement/customCategoryProduct`, data)
  },
  // 修改排序
  updateDisplayOrder(id: number, data: any) {
    return Ajax.put(`/api/productManagement/customCategoryProduct/${id}`, data)
  }
}
